import type { PackFeature } from "@/modules/corporate/types/pricing"
import type { FunctionComponent, HTMLAttributes } from "react"

import { Fragment } from "react"

import { IconPackState } from "@/modules/corporate/components/Sections/Pricing/components/IconPackState/IconPackState"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./FeaturePackCell.module.css"

type FeaturePackCellProps = { feature: PackFeature } & HTMLAttributes<HTMLTableCellElement>

export const FeaturePackCell: FunctionComponent<FeaturePackCellProps> = ({ feature, ...restProps }) => {
  const { t } = useTranslation(["corporate"])

  if (feature.hasOwnProperty("included") && typeof feature?.included === "boolean") {
    return (
      <td {...restProps} className={styles.featurePackCell}>
        <IconPackState aria-label={t(feature["aria-label"])} included={feature.included} />
      </td>
    )
  }

  return (
    <td {...restProps} className={styles.featurePackCell}>
      <div className={styles.text}>
        {feature?.description?.map(item => {
          if (typeof item === "string") {
            return <Fragment key={item}>{t(item)}</Fragment>
          }

          return (
            <strong className={styles.bold} key={item.bold}>
              {t(item.bold)}
            </strong>
          )
        })}
      </div>
    </td>
  )
}
